export const rankingFetching = (ranking) => {
  const result = {
    ...ranking,
    isFetching: true,
  };
  return result;
};

export const rankingData = (ranking, data) => {
  const result = {
    ...ranking,
    rankings: data,
    isFetching: false,
  };
  return result;
};

export const rankingError = (ranking, error) => {
  const result = {
    ...ranking,
    errorMessage: error,
    isFetching: false,
  };
  return result;
};

export const categoryFetching = (category) => {
  const result = {
    ...category,
    isFetching: true,
  };
  return result;
};

export const categoryData = (category, data) => {
  const result = {
    ...category,
    categories: data,
    isFetching: false,
  };
  return result;
};

export const categoryError = (category, error) => {
  const result = {
    ...category,
    errorMessage: error,
    isFetching: false,
  };
  return result;
};

export const appendCategory = (category, categories) => {
  let tempList = categories.filter(
    (item) => item.categoryCode !== category.categoryCode
  );
  tempList.push(category);
  return tempList;
};

export const removeCategory = (category, categories) => {
  let tempList = categories.filter(
    (item) => item.categoryCode !== category.categoryCode
  );
  return tempList;
};

export const userCategoryFetching = (userCategory) => {
  const result = {
    ...userCategory,
    isFetching: true,
  };
  return result;
};

export const userCategoryData = (userCategory, data) => {
  const result = {
    ...userCategory,
    userCategories: data,
    isFetching: false,
  };
  return result;
};

export const userCategoryError = (userCategory, error) => {
  const result = {
    ...userCategory,
    userCategories: [],
    errorMessage: error,
    isFetching: false,
  };
  return result;
};

export const queryData = (query, data) => {
  const result = {
    ...query,
    data,
  };
  return result;
};

export const saveUserCategories = (categories) => {
  const result = categories.map((element, idx) => ({
    categoryCode: element.categoryCode,
    subCategory: element.subCategory,
    sequence: parseInt(idx + 1),
    color: element.color,
  }));

  return result;
};

export const pullUserCategories = (data, main) => {
  let categories = [];
  main.forEach((element) => {
    categories.push.apply(categories, element.category);
  });

  const result = data.map((element, idx) => {
    const category = categories.filter(
      (item) => item.categoryCode === element.categoryCode
    )[0];
    return {
      subCategory: category.subCategory,
      categoryCode: category.categoryCode,
      sequence: idx + 1,
      color: element.color,
    };
  });
  return result;
};

// export const checkExistedCategory = (categoryCode, main) => {
//   let categories = [];
//   main.categoryList.forEach((element) => {
//     categories.push.apply(categories, element.category);
//   });
//   main.customCategoryList.forEach((element) => {
//     categories.push({
//       subCategory: element.customCategoryName,
//       categoryCode: element.customCategoryCode
//     });
//   });
//   if (categories.some((j) => j.categoryCode === categoryCode)) {
//     return true;
//   } else {
//     return false;
//   }
// };

export const checkExistedCategory = (categoryCode, userCategories) => {
  if (userCategories.some((j) => j.categoryCode === categoryCode)) {
    let selectedCategory = userCategories.find(
      (j) => j.categoryCode === categoryCode
    );
    return selectedCategory.sequence;
  } else {
    return false;
  }
};

// Retunr Sequence and boolean
// export const checkedCategory = (categoryCode, userCategories) => {
//   let fund = userCategories.filter((j) => j.categoryCode === categoryCode);
//   if (fund.length > 0) {
//     return {
//       value: true,
//       sequences: fund[0].sequences
//     };
//   } else {
//     return false;
//   }
// };

export const saveFavCategories = (userCategories) => {
  return userCategories.map((item) => {
    return {
      categoryCode: item.categoryCode,
      subCategory: item.subCategory,
      sequence: item.sequence,
      color: item.color,
    };
  });
};

export const setIsFetching = (state) => {
  const result = {
    ...state,
    isFetching: true,
  };
  return result;
};

export const filterDataResult = (state, data) => {
  const result = {
    ...state,
    isFetching: false,
    data: data ?? {},
    errorMessage: null,
  };
  return result;
};

export const resetDataResult = (state, message) => {
  const result = {
    ...state,
    isFetching: false,
    data: [],
    errorMessage: message,
  };
  return result;
};

export const resetDataResultToObject = (state, message) => {
  const result = {
    ...state,
    isFetching: false,
    data: {},
    errorMessage: message,
  };
  return result;
};

export const setDefaultQueriesFundRanking = (state, data) => {
  const result = {
    ...state,
    categoryCode: state.categoryCode.length > 0 ? state.categoryCode : [],
    dividendPolicy: data.dividendPolicy[0].code,
    fundTypes:
      state.fundTypes.length > 0
        ? state.fundTypes
        : data.fundTypes.map((item) => item.code),
    investorRatings: data.investorRatings.map((item) => item.code),
    purchaseFee: data.purchaseFee[0].code,
    currencyPolicy: data.currencyPolicy[0].code,
    riskLevels: data.riskLevels.map((item) => item.code),
    morningStarRatings: data.morningStarRatings.map((item) => item.code),
    company: data.company.map((item) => item.id),
  };
  return result;
};
